import 'regenerator-runtime/runtime'
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom/client'

import './index.module.scss'
import { BrowserRouter, useLocation } from 'react-router-dom'

import { initSentry } from 'utils/sentry'

import Router from './Router'

initSentry()

const callbackHistory: Array<(callback: (location: any) => void) => void> = []

window.PLURALL_CUSTOM_HISTORY = {
  listen: callback => {
    if (!callbackHistory.find(c => c === callback)) {
      callbackHistory.push(callback)
    }
  },
}

const History = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation()

  useEffect(() => {
    callbackHistory.forEach(callback => {
      callback(location as any)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location])

  return children
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <BrowserRouter>
    <History>
      <Router />
    </History>
  </BrowserRouter>,
)
